import React from "react";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import CaptchaForm from "assets/scripts/components/common/form/CaptchaForm/CaptchaForm";
import { defineMessages, FormattedMessage } from "react-intl";
import { useEffect } from "react";
import { connect } from "react-redux";
import { signUpWithToken } from "assets/scripts/domain/validation/validationActions";
import styles from "./SignUpToken.module.less";
const messages = defineMessages({
    submit: {
        id: "forms.accountNew.submit",
        defaultMessage: "Continue"
    }
});
function SignUpToken(props) {
    const { token } = props.params;
    const { isRequiredCaptcha } = props;
    useEffect(() => {
        if (props.loading == null && !isRequiredCaptcha) {
            props.signUpWithToken(token, null);
        }
    }, [props.loading, isRequiredCaptcha]);
    const isCaptchaError = props.error?.response?.status === 417
        || props.error?.response?.status === 429;
    return (<div className="wrapper">
			<div className="content mix-content_centerText">
				<StatusMessage isLoad isActive={props.loading || (props.loading == null && !isRequiredCaptcha)}/>

				{props.error != null && !isCaptchaError && (<FormattedMessage id="account.closed.message" defaultMessage="We apologize for the inconvenience but we are unable to add this account. Please contact our office at 1-877-326-8786."/>)}

				{(props.error == null || isCaptchaError) && isRequiredCaptcha && (<CaptchaForm onSubmit={captchaResponse => {
        props.signUpWithToken(token, captchaResponse);
    }} isBusy={props.loading ?? false} submitLabel={messages.submit} className={styles.form} hideRequiredMessage isValid force>
						{captcha => captcha}
					</CaptchaForm>)}
			</div>
		</div>);
}
export default connect((state, _ownProps) => ({
    ...state.validation.registerDirectLink,
    isRequiredCaptcha: state.auth.isRequiredCaptcha
}), {
    signUpWithToken
})(SignUpToken);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/SignUpToken/SignUpToken.tsx